module.exports = __webpack_public_path__ + "img/img25.2ee5fa9a.svg";